const config = {
  apiGateway: {
    REGION: 'eu-west-1',
    INTERNAL_API_URL: 'https://0ej5wbsma2.execute-api.eu-west-1.amazonaws.com/prod',
    COMPANY_API_URL: 'https://cxs6t33q81.execute-api.eu-west-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'DO-5380-pt-med-4-missing-subresource-integrity-SRI-on-CDN-Resources',
    HOSTNAME: 'https://company.testing.eurecovery.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.testing.eurecovery.forwoodsafety.com',
    WEBSOCKET: 'wss://mx3s7li7i2.execute-api.eu-west-1.amazonaws.com/testing'
  },
};

export default config;